import { cn } from "@/lib/utils";

type FactItems = Record<string, { label: string; value: string }>;

/** Key facts set as a ruled spec sheet. */
export function Facts({
	items,
	className,
}: {
	items: FactItems;
	className?: string;
}) {
	return (
		<dl
			className={cn(
				"grid border-t sm:grid-cols-3 sm:divide-x sm:divide-border",
				className,
			)}
		>
			{Object.entries(items).map(([key, item]) => (
				<div
					key={key}
					className="border-b py-5 sm:border-b-0 sm:px-6 sm:first:pl-0 sm:last:pr-0"
				>
					<dt className="font-mono text-[11px] tracking-[0.07em] text-muted-foreground uppercase">
						{item.label}
					</dt>
					<dd className="mt-2 text-pretty font-medium">{item.value}</dd>
				</div>
			))}
		</dl>
	);
}
